"use client";

import React from "react";
import { METRICS_EVENTS } from "@cede/types";
import { WheelSpinIcon } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { useHubUser } from "@/hooks";
import { useMetricsEvents } from "@/hooks/data/useMetricsEvents";
import { History } from "lucide-react";

interface WheelTicketsDisplayProps {
  tickets: number;
  isLoading: boolean;
  onGetMore: () => void;
  onViewHistory?: () => void;
}

/**
 * Displays the user's ticket count and provides actions to get more or view history
 */
export const WheelTicketsDisplay: React.FC<WheelTicketsDisplayProps> = ({
  tickets,
  isLoading,
  onGetMore,
  onViewHistory,
}) => {
  const { hubUser } = useHubUser();
  const { trackEvent } = useMetricsEvents();

  const handleViewHistory = () => {
    // Track when user opens spinning wheel history view
    trackEvent(METRICS_EVENTS.SPINNING_WHEEL_VIEW_HISTORY_CLICKED, {
      hubUserId: hubUser?.id,
    });
    onViewHistory?.();
  };

  return (
    <div className="flex flex-col items-center gap-3 bg-cede-bg-component rounded-large border-container px-4 py-3">
      <div className="text-xs text-cede-text-secondary">Tickets</div>
      <div className="flex items-center gap-2">
        <div className="text-3xl font-bold text-cede-primary">{isLoading ? "..." : tickets}</div>
        <WheelSpinIcon width={24} height={24} fill="#5EA6FF" />
      </div>
      {/* Get More Tickets Button */}
      <Button
        onClick={onGetMore}
        variant={tickets === 0 ? "primary" : "transparent-bordered"}
        size="small"
        className="text-xs h-7"
      >
        Get More
      </Button>
      {/* Win History Button */}
      {onViewHistory && (
        <Button
          onClick={handleViewHistory}
          variant="transparent-bordered"
          size="small"
          className="text-xs h-7 w-full flex items-center justify-center gap-1"
        >
          <History className="w-3 h-3" />
          Claim Rewards
        </Button>
      )}
    </div>
  );
};
